import { useState } from "react";
import MaterialInput from "../../helperComponents/MaterialInput";
import employeeShiftTypes from "../../../data/employee/employeeShiftTypes";
import DropDownInput from "../../helperComponents/DropDownInput";
import DailyResponsibilityCore from "./DailyResponsibilityCore";

let supportedFields = [
  "Zone Name",
  // "Site Codename",
  "Site Place Name",
  "Profile Nickname",
  "Profile First Name",
  "Profile Last Name",
  "Shift",

  "Profile Registration Number",
  "Employee Responsibility",
  "Day Of Rest",
  // "Absence", //absence is rendered using custom cell so it is disabled here
  "Dispute",
  "Vacation",
];

let initialSelectedFields = [
  "Profile Nickname",
  // "Site Codename",
  "Site Place Name",
  "Zone Name",
  "Profile First Name",
  "Profile Last Name",
  "Shift",
  // "Absence", //absence is rendered using custom cell so it is disabled here
  "Profile Registration Number",
  "Employee Responsibility",
  "Day Of Rest",

  "Dispute",
  "Vacation",
];

export default function DailyResponsibility({
  dateProp,
  shiftProp,
  hideDateFilter,
  hideShiftFilter,
  hideAllFilters,
  disableTitle,
  readOnly,
}) {
  const [date, setDate] = useState(null);
  const [shift, setShift] = useState("12H-DAY");

  let theDate = dateProp ? dateProp : date;
  let theShift = shiftProp ? shiftProp : shift;

  return (
    <DailyResponsibilityCore
      readOnly={readOnly}
      date={theDate}
      shift={theShift}
      title={disableTitle ? null : "Presentation du Staff Journalier"}
      hideAllFilters={hideAllFilters}
      filters={
        <>
          {hideDateFilter ? null : (
            <MaterialInput
              type="date"
              label={"Date"}
              value={date}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
          )}

          {hideShiftFilter ? null : (
            <DropDownInput
              label={"Shift"}
              options={employeeShiftTypes}
              value={shift}
              onChange={setShift}
            />
          )}
        </>
      }
    />
  );
}
